import useCreateCityAccessControl, {
  CreateCityAccessControlProps,
  translatedCreateCityAccessControlProps,
} from 'modules/cities/hooks/use-create-city-access-control';
import usePermissionGroupsForCitiesSelect from 'modules/permission-groups/hooks/use-permission-groups-for-cities-select-data';
import useUsersSelect from 'modules/users/hooks/use-users-select';
import {useLocation, useParams} from 'react-router-dom';
import Creation from 'shared/layout/creation';
import useFormInputs from 'shared/migration-components/form/util';

const CreateAccessControl: React.FC = () => {
  const {id} = useParams();
  const {state: workingPeriod} = useLocation();
  const {getSelect, getSwitch, getInput} =
    useFormInputs<CreateCityAccessControlProps>();
  const userSelect = useUsersSelect();
  const permissionGroupsSelect = usePermissionGroupsForCitiesSelect();

  return (
    <Creation
      defaultValues={{active: true, ...(workingPeriod ?? {})}}
      translationKey={translatedCreateCityAccessControlProps}
      onSubmit={() => useCreateCityAccessControl(id!)}
      inputs={[
        getSwitch({
          name: 'createUser',
        }),
        getSelect({
          name: 'userId',
          data: userSelect.data,
          isLoading: userSelect.isLoading,
          hidden: (data) => !!data.createUser,
        }),
        getInput({
          name: 'user.name',
          hidden: (data) => !data.createUser,
        }),
        getInput({
          name: 'user.email',
          hidden: (data) => !data.createUser,
        }),
        getInput({
          name: 'user.password',
          secureText: true,
          hidden: (data) => !data.createUser,
        }),
        getSelect({
          name: 'permissionGroupId',
          data: permissionGroupsSelect.data,
          isLoading: permissionGroupsSelect.isLoading,
        }),
      ]}
      border
    />
  );
};

export default CreateAccessControl;
